import React,{ Component, PropTypes } from 'react';
import ReactDOM, { findDOMNode } from 'react-dom';
import { connect } from 'react-redux'
import deepcopy from 'deepcopy'
import { ItemTypes } from './Constants';
import { DragSource, DropTarget } from 'react-dnd';
import RowSettings from './RowSettings';
import ColumnLayout from './ColumnLayout';
import Column from './Column';
import { changeIdofBlock } from '../helpers/commonHelper';
import { changeColumn, columnSortable, toggleCollapse, addBlock } from '../actions/index';
import AddNewRowButton from './AddNewRowButton';
import _ from 'lodash'

import deepEqual from 'deep-equal'

const rowSource = {
  beginDrag(props){
    return {
      id: props.id,
      index: props.index
    }
  }
}

const rowTarget = {
  hover(props, monitor, component) {
    const dragItem = monitor.getItem();
    const dragIndex = dragItem.index;
    const hoverIndex = props.index;

    if (dragIndex === hoverIndex) {
      return;
    }

    const element = findDOMNode(component);
    const hoverBoundingRect = element.getBoundingClientRect();
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    const clientOffset = monitor.getClientOffset();
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    if(dragItem.type == 'block'){

    } else {
      props.moveRow(dragIndex, hoverIndex);
      monitor.getItem().index = hoverIndex;
    }

    if(monitor.isOver({ shallow: true })){
      if (hoverClientY < hoverMiddleY) {
        element.classList.remove('bottom-placeholder');
        element.classList.add('top-placeholder');
      }
      if (hoverClientY > hoverMiddleY) {
        element.classList.add('bottom-placeholder');
        element.classList.remove('top-placeholder');
      }
    }


  },
  drop(props, monitor, component){
    const item = monitor.getItem();

    if(item.type == 'block'){
      const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      let index = props.index;

      if (hoverClientY > hoverMiddleY) {
        index = index + 1;
      }

      let blockData
      if (typeof item.element.section == 'string') {
        blockData = JSON.parse(item.element.section)
      } else {
        blockData = item.element.section
      }

      let newBlockData = changeIdofBlock(deepcopy(blockData))

      props.addBlockAsRow(index, newBlockData);

      let element = findDOMNode(component);
      element.classList.remove('sppb-block-bottom-placeholder');
      element.classList.remove('sppb-block-top-placeholder');
    }
  }
};

class Row extends Component {

  shouldComponentUpdate(nextProps, nextState){
    setTimeout(() => {
      window.frames['sp-pagebuilder-view'].window.jQuery(window.frames['sp-pagebuilder-view'].window).trigger('resize');
    }, 300);

    if(
      deepEqual(nextProps.row, this.props.row) &&
      deepEqual(nextProps.id, this.props.id) &&
      deepEqual(nextProps.index, this.props.index) &&
      deepEqual(nextProps.isDragging, this.props.isDragging) &&
      deepEqual(nextProps.isOver, this.props.isOver) &&
      deepEqual(nextProps.isOverCurrent, this.props.isOverCurrent) &&
      deepEqual(nextState, this.state)){
      return false;
    }

    return true;
  }

  componentDidMount() {
    this.props.connectDragPreview( this.createCustomDragSource() );
    const { row } = this.props;

    // Video Player
    var videoId = '#section-id-' + row.id;
    if (typeof row.settings.background_video !== 'undefined' && row.settings.background_video == 1 && typeof row.settings.background_video_mp4 !== 'undefined' && row.settings.background_video_mp4 !='') {
      var background_video_mp4 = pagebuilder_base + row.settings.background_video_mp4;
      jQuery(''+ videoId +'', window.frames['sp-pagebuilder-view'].window.document).vide(
        { mp4:background_video_mp4 },
        { posterType:'none', className:'sppb-bg-video-player' }
      );
    } else if (typeof row.settings.background_video !== 'undefined' && row.settings.background_video == 1 && typeof row.settings.background_video_ogv !== 'undefined' && row.settings.background_video_ogv !='') {
      var background_video_ogv = pagebuilder_base + row.settings.background_video_ogv;
      jQuery(''+ videoId +'', window.frames['sp-pagebuilder-view'].window.document).vide(
        { ogv:background_video_ogv },
        { posterType:'none', className:'sppb-bg-video-player' }
      );
    }

    // Parallax
    if (typeof row.settings.background_parallax !== 'undefined' && row.settings.background_parallax == 1 && typeof window.frames['sp-pagebuilder-view'].window.jQuery.fn.parallax !== 'undefined') {
      window.frames['sp-pagebuilder-view'].window.jQuery(videoId).parallax();
    } else if(typeof row.settings.background_parallax !== 'undefined' && row.settings.background_parallax == 0 && typeof window.frames['sp-pagebuilder-view'].window.jQuery.fn.parallaxDestroy !== 'undefined'){
      let bgAttachment = 'inherit';
      if (typeof row.settings.background_attachment !== 'undefined' && row.settings.background_attachment) {
        bgAttachment = row.settings.background_attachment;
      }

      let bgPosition = '0 0';
      if (typeof row.settings.background_position !== 'undefined' && row.settings.background_position) {
        bgPosition = row.settings.background_position;
      }
      window.frames['sp-pagebuilder-view'].window.jQuery(videoId).parallaxDestroy(bgPosition, bgAttachment);
    }

    if (typeof row.settings.background_external_video !== 'undefined' && row.settings.background_external_video != '' && typeof row.settings.external_background_video !== 'undefined' && row.settings.external_background_video == 1) {
      window.frames['sp-pagebuilder-view'].window.sppbVideoBackgroundResize(jQuery(videoId, window.frames['sp-pagebuilder-view'].window.document));
    }
  }


  componentDidUpdate() {
    this.props.connectDragPreview( this.createCustomDragSource() );
    const { row } = this.props;

    // Video Player
    var videoId = '#section-id-' + row.id;
    if (typeof row.settings.background_video !== 'undefined' && row.settings.background_video == 1 && typeof row.settings.background_video_mp4 !== 'undefined' && row.settings.background_video_mp4) {
      var background_video_mp4 = pagebuilder_base + row.settings.background_video_mp4;
      jQuery(''+ videoId +'', window.frames['sp-pagebuilder-view'].window.document).vide(
        { mp4:background_video_mp4 },
        { posterType:'none', className:'sppb-bg-video-player' }
      );
    } else if (typeof row.settings.background_video !== 'undefined' && row.settings.background_video == 1 && typeof row.settings.background_video_ogv !== 'undefined' && row.settings.background_video_ogv) {
      var background_video_ogv = pagebuilder_base + row.settings.background_video_ogv;
      jQuery(''+ videoId +'', window.frames['sp-pagebuilder-view'].window.document).vide(
        { ogv:background_video_ogv },
        { posterType:'none', className:'sppb-bg-video-player' }
      );
    } else {
      jQuery(''+ videoId +'', window.frames['sp-pagebuilder-view'].window.document).find('.sppb-bg-video-player').remove();
    }

    // Parallax
    if (typeof row.settings.background_parallax !== 'undefined' && row.settings.background_parallax == 1 && typeof window.frames['sp-pagebuilder-view'].window.jQuery.fn.parallax !== 'undefined') {
      window.frames['sp-pagebuilder-view'].window.jQuery(videoId).parallax();
    } else if(typeof row.settings.background_parallax !== 'undefined' && row.settings.background_parallax == 0 && typeof window.frames['sp-pagebuilder-view'].window.jQuery.fn.parallaxDestroy !== 'undefined'){
      let bgAttachment = 'inherit';
      if (typeof row.settings.background_attachment !== 'undefined' && row.settings.background_attachment) {
        bgAttachment = row.settings.background_attachment;
      }

      let bgPosition = '0 0';
      if (typeof row.settings.background_position !== 'undefined' && row.settings.background_position) {
        bgPosition = row.settings.background_position;
      }
      window.frames['sp-pagebuilder-view'].window.jQuery(videoId).parallaxDestroy(bgPosition, bgAttachment);
    }

    if (typeof row.settings.background_external_video !== 'undefined' && row.settings.background_external_video != '' && typeof row.settings.external_background_video !== 'undefined' && row.settings.external_background_video == 1) {
      window.frames['sp-pagebuilder-view'].window.sppbVideoBackgroundResize(jQuery(videoId, window.frames['sp-pagebuilder-view'].window.document));
    }
  }

  createCustomDragSource(){
    var rowDragImg = pagebuilder_base + 'components/com_sppagebuilder/assets/images/row.png';
    var img = new Image();
    img.src = rowDragImg;

    return img
  }

  getRowStyle(){
    const { settings } = this.props.row;
    var styles = {};

    if (typeof settings.background_color !== 'undefined' && settings.background_color) {
      styles.backgroundColor = settings.background_color;
    }

    if (typeof settings.color !== 'undefined' && settings.color) {
      styles.color = settings.color;
    }


    if (typeof settings.background_image !== 'undefined' && settings.background_image) {

      var bdImage = settings.background_image;

      if (bdImage.startsWith('http') == true) {
        bdImage = settings.background_image;
      } else {
        bdImage = pagebuilder_base + settings.background_image;
      }

      styles.backgroundImage = 'url(' + bdImage + ')';

      if (typeof settings.background_repeat !== 'undefined' && settings.background_repeat) {
        styles.backgroundRepeat = settings.background_repeat;
      }

      if (typeof settings.background_size !== 'undefined' && settings.background_size) {
        styles.backgroundSize = settings.background_size;
      }

      if (typeof settings.background_attachment !== 'undefined' && settings.background_attachment) {
        styles.backgroundAttachment = settings.background_attachment;
      }

      if (typeof settings.background_position !== 'undefined' && settings.background_position) {
        styles.backgroundPosition = settings.background_position;
      }
    }

    return styles;
  }

  getRowCustomClass(){
    let customClass = 'sp-pagebuilder-section sppb-section';
    const { settings } = this.props.row;

    if (typeof settings.class !== 'undefined' && settings.class) {
      customClass = customClass + ' ' + settings.class;
    }

    if (typeof settings.columns_equal_height !== 'undefined' && settings.columns_equal_height == '1') {
      customClass = customClass + ' sppb-equalize-columns';
    }

    if (typeof settings.hidden_md !== 'undefined' && settings.hidden_md == '1') {
      customClass = customClass + ' sppb-hidden-md sppb-hidden-lg';
    }

    if (typeof settings.hidden_sm !== 'undefined' && settings.hidden_sm == '1') {
      customClass = customClass + ' sppb-hidden-sm';
    }

    if (typeof settings.hidden_xs !== 'undefined' && settings.hidden_xs == '1') {
      customClass = customClass + ' sppb-hidden-xs';
    }

    if (typeof settings.animation !== 'undefined' && settings.animation ) {
      customClass = customClass + ' sppb-wow ' + settings.animation;
    }

    if (typeof settings.background_external_video !== 'undefined' && settings.background_external_video ) {
      customClass += ' sppb-row-have-ext-bg' ;
    }

    return customClass;
  }

  getSectionTitle(){
    const { settings } = this.props.row;
    let html = '';

    if ((typeof settings.title !=='undefined' && settings.title !='') || (typeof settings.subtitle !=='undefined' && settings.subtitle !='')) {
      if (settings.fullscreen !=='undefined' && settings.fullscreen == 1) {
        html += '<div class="sppb-container">';
      }

      let title_position = '';
      if (typeof settings.title_position !=='undefined' && settings.title_position) {
        title_position = settings.title_position;
      }

      var secStyle = '';
      if (typeof settings.title_section_padding !=='undefined' && settings.title_section_padding != '') {
        secStyle += 'padding: '+ settings.title_section_padding  + ';';
      }

      if (typeof settings.title_section_margin !=='undefined' && settings.title_section_margin != '') {
        secStyle += 'margin: '+ settings.title_section_margin  + ';';
      }

      html += '<div class="sppb-section-title ' + title_position +'" style="'+ secStyle +'">';

      /* Section Title */
      if (typeof settings.title !=='undefined' && settings.title) {
        let heading_selector = 'h2';
        if (typeof settings.heading_selector !=='undefined' && settings.heading_selector) {
          heading_selector = settings.heading_selector;
        }

        let hStyle = '';

        if (typeof settings.title_fontweight !=='undefined' && settings.title_fontweight != '') {
          hStyle += 'font-weight: '+ settings.title_fontweight + ';';
        }

        if (typeof settings.title_text_color !=='undefined' && settings.title_text_color != '') {
          hStyle += 'color: '+ settings.title_text_color  + ';';
        }

        html +='<'+heading_selector+' class="sppb-title-heading" style="'+ hStyle +'">'+ settings.title +'</'+heading_selector+'>';

        if (typeof settings.subtitle !=='undefined' && settings.subtitle != '') {
          html += '<p class="sppb-title-subheading" style="';

          if (typeof settings.subtitle_fontsize !=='undefined' && settings.subtitle_fontsize != '') {
            html += 'font-size: '+ settings.subtitle_fontsize  + 'px;';
          }

          html += '">'+ settings.subtitle +'</p>';
        }
      }
      html += '</div>';

      if (settings.fullscreen !=='undefinded' && settings.fullscreen == 1) {
        html += '</div>';
      }
    }

    return html;
  }

  parseUrl(str){
    var query

    var key = [
      'source',
      'scheme',
      'authority',
      'userInfo',
      'user',
      'pass',
      'host',
      'port',
      'relative',
      'path',
      'directory',
      'file',
      'query',
      'fragment'
    ]

    // For loose we added one optional slash to post-scheme to catch file:/// (should restrict this)
    var parser = new RegExp([
        '(?:([^:\\/?#]+):)?',
        '(?:\\/\\/()(?:(?:()(?:([^:@\\/]*):?([^:@\\/]*))?@)?([^:\\/?#]*)(?::(\\d*))?))?',
        '()',
        '(?:(()(?:(?:[^?#\\/]*\\/)*)()(?:[^?#]*))(?:\\?([^#]*))?(?:#(.*))?)'
      ].join(''));

    var m = parser.exec(str)
    var uri = {}
    var i = 14

    while (i--) {
      if (m[i]) {
        uri[key[i]] = m[i]
      }
    }

    delete uri.source
    return uri
  }

  externalVideo(){
    const { row } = this.props;
    if ((typeof row.settings.background_external_video === 'undefined' || row.settings.background_external_video == '') || (typeof row.settings.external_background_video !== 'undefined' && row.settings.external_background_video == 0) || row.settings.background_video == 0) {
      return;
    }
    var video = this.parseUrl(row.settings.background_external_video),
        src = '';
    if (video.host == 'youtu.be') {
      var id = video['path'].replace('/', '');
      src = '//www.youtube.com/embed/'+id+'?playlist='+id+'&iv_load_policy=3&enablejsapi=1&disablekb=1&autoplay=1&controls=0&showinfo=0&rel=0&loop=1&wmode=transparent&widgetid=1&mute=1';
    } else if(video.host == 'www.youtube.com' || video.host == 'youtube.com'){
      var id = video['query'].replace('v=', '');
      src = '//www.youtube.com/embed/'+id+'?playlist='+id+'&iv_load_policy=3&enablejsapi=1&disablekb=1&autoplay=1&controls=0&showinfo=0&rel=0&loop=1&wmode=transparent&widgetid=1&mute=1';
    } else if (video.host == 'vimeo.com' || video.host == 'www.vimeo.com') {
      var id = video['path'].replace('/', '');
      src = "//player.vimeo.com/video/"+id+"?autoplay=1&loop=1&title=0&byline=0&portrait=0"
    }
    return (
      <div className="sppb-youtube-video-bg hidden"><iframe src={src} frameBorder="0" allowFullScreen></iframe></div>
    )
  }

  render() {
    const { id, row, index, isOver, canDrop, isDragging, connectDropTarget, connectDragPreview, connectDragSource, isOverCurrent } = this.props;

    var row_class = 'sppb-row';
    let fluid_row = 0;

    var overlayStyle = {};

    var margin = window.getMarginPadding(row.settings.margin, 'margin');
    var padding = window.getMarginPadding(row.settings.padding, 'padding');

    if (!_.isObject(margin)) {
      margin = {
        md: margin,
        sm: '',
        xs: ''
      }
    }

    if (!_.isObject(padding)) {
      padding = {
        md: padding,
        sm: '',
        xs: ''
      }
    }

    if(typeof row.settings !=='undefined'){
      if (typeof row.settings.no_gutter !=='undefined' && row.settings.no_gutter == 1) {
        row_class = row_class + ' sppb-no-gutter';
      }

      if (typeof row.settings.columns_align_center !=='undefined' && row.settings.columns_align_center == 1) {
        row_class = row_class + ' sppb-align-center';
      }


      if (row.settings.fullscreen != undefined) {
        fluid_row = row.settings.fullscreen;
      }



      if (typeof row.settings.animationduration !== 'undefined' && row.settings.animationduration !='') {
        var animationduration = row.settings.animationduration+'ms';
      }

      if (typeof row.settings.animationdelay !== 'undefined' && row.settings.animationdelay !='') {
        var animationdelay = row.settings.animationdelay+'ms';
      }
      if (typeof row.settings.overlay !== 'undefined' && row.settings.overlay !='') {
        overlayStyle.backgroundColor = row.settings.overlay;
      }
    }


    var customClass;
    if (isDragging && !isOver) {
        var customClass = 'sp-pagebuilder-section-inner sp-pagebuilder-row-drag';
    }else{
        var customClass = 'sp-pagebuilder-section-inner';
    }

    var overClass= 'sp-pagebuilder-section-parent';
    if (isOver && !isDragging) {
      // overClass = overClass + ' sp-pagebuilder-row-over';
    }

    if (!row.visibility) {
      overClass = overClass + ' sp-pagebuilder-row-disable';
    }

    if(isOverCurrent){
      overClass = overClass + ' sp-pagebuilder-show-placeholder';
    }

    const rowIndex = index;
    let colLength = row.columns.length;



    let rowId = 'section-id-' + row.id;
    let styles = this.getRowStyle();
    let sectionClass = this.getRowCustomClass();
    let cusHtml = this.getSectionTitle();


    let topShape = sppbSvgShape[row.settings.shape_name];

    if(row.settings.shape_invert && sppbSvgShape[row.settings.shape_name+'-invert'] !== undefined){
      topShape = sppbSvgShape[row.settings.shape_name+'-invert'];
    }

    let bottomShape = sppbSvgShape[row.settings.bottom_shape_name];
    
    if(row.settings.bottom_shape_invert && sppbSvgShape[row.settings.bottom_shape_name+'-invert'] !== undefined){
      bottomShape = sppbSvgShape[row.settings.bottom_shape_name+'-invert'];
    }


    let shapeClass = '';
    let bottomShapeClass = '';

    if(row.settings.shape_flip){
      shapeClass += ' sppb-shape-flip';
    }

    if(row.settings.shape_invert && sppbSvgShape[row.settings.shape_name+'-invert'] !== undefined){
      shapeClass += ' sppb-shape-invert';
    }

    if(row.settings.shape_to_front){
      shapeClass += ' sppb-shape-to-front';
    }

    if(row.settings.bottom_shape_flip){
      bottomShapeClass += ' sppb-shape-flip';
    }

    if(row.settings.bottom_shape_invert && sppbSvgShape[row.settings.bottom_shape_name+'-invert'] !== undefined){
      bottomShapeClass += ' sppb-shape-invert';
    }

    if(row.settings.bottom_shape_to_front){
      bottomShapeClass += ' sppb-shape-to-front';
    }

    let topShapeCss = '';
    let topShapeCss_sm = '';
    let topShapeCss_xs = '';

    if(row.settings.shape_width !== undefined && _.isObject(row.settings.shape_width)){
      topShapeCss += `width: ${row.settings.shape_width.md}%;max-width: ${row.settings.shape_width.md}%;`;
      topShapeCss_sm += `width: ${row.settings.shape_width.sm}%;max-width: ${row.settings.shape_width.sm}%;`;
      topShapeCss_xs += `width: ${row.settings.shape_width.xs}%;max-width: ${row.settings.shape_width.xs}%;`;
    }

    if(row.settings.shape_height !== undefined && _.isObject(row.settings.shape_height)){
      topShapeCss += `height: ${row.settings.shape_height.md}px;`;
      topShapeCss_sm += `height: ${row.settings.shape_height.sm}px;`;
      topShapeCss_xs += `height: ${row.settings.shape_height.xs}px;`;
    }

    let bottomShapeCss = '';
    let bottomShapeCss_sm = '';
    let bottomShapeCss_xs = '';

    if(row.settings.bottom_shape_width !== undefined && _.isObject(row.settings.bottom_shape_width)){
      bottomShapeCss += `width: ${row.settings.bottom_shape_width.md}%;max-width: ${row.settings.bottom_shape_width.md}%;`;
      bottomShapeCss_sm += `width: ${row.settings.bottom_shape_width.sm}%;max-width: ${row.settings.bottom_shape_width.sm}%;`;
      bottomShapeCss_xs += `width: ${row.settings.bottom_shape_width.xs}%;max-width: ${row.settings.bottom_shape_width.xs}%;`;
    }

    if(row.settings.bottom_shape_height !== undefined && _.isObject(row.settings.bottom_shape_height)){
      bottomShapeCss += `height: ${row.settings.bottom_shape_height.md}px;`;
      bottomShapeCss_sm += `height: ${row.settings.bottom_shape_height.sm}px;`;
      bottomShapeCss_xs += `height: ${row.settings.bottom_shape_height.xs}px;`;
    }

    let title_css = ''
    let title_css_sm = ''
    let title_css_xs  = ''

    if(row.settings.title !== undefined && row.settings.title != ''){
      if(_.isObject(row.settings.title_fontsize)){
        title_css += `#${rowId} .sppb-section-title .sppb-title-heading{`;
        title_css += `font-size: ${row.settings.title_fontsize.md}px;line-height: ${row.settings.title_fontsize.md}px;`;
        title_css += `}`;

        title_css_sm += `#${rowId} .sppb-section-title .sppb-title-heading{`;
        title_css_sm += `font-size: ${row.settings.title_fontsize.sm}px;line-height: ${row.settings.title_fontsize.sm}px;`;
        title_css_sm += `}`;

        title_css_xs += `#${rowId} .sppb-section-title .sppb-title-heading{`;
        title_css_xs += `font-size: ${row.settings.title_fontsize.xs}px;line-height: ${row.settings.title_fontsize.xs}px;`;
        title_css_xs += `}`;
      } else {
        title_css += `#${rowId} .sppb-section-title .sppb-title-heading{`;
        title_css += `font-size: ${row.settings.title_fontsize}px;line-height: ${row.settings.title_fontsize}px;`;
        title_css += `}`;
      }

      if(_.isObject(row.settings.title_margin_top)){
        title_css += `#${rowId} .sppb-section-title .sppb-title-heading{`;
        title_css += `margin-top: ${row.settings.title_margin_top.md}px;`;
        title_css += `}`;

        title_css_sm += `#${rowId} .sppb-section-title .sppb-title-heading{`;
        title_css_sm += `margin-top: ${row.settings.title_margin_top.sm}px;`;
        title_css_sm += `}`;

        title_css_xs += `#${rowId} .sppb-section-title .sppb-title-heading{`;
        title_css_xs += `margin-top: ${row.settings.title_margin_top.xs}px;`;
        title_css_xs += `}`;
      } else {
        title_css += `#${rowId} .sppb-section-title .sppb-title-heading{`;
        title_css += `margin-top: ${row.settings.title_margin_top}px;`;
        title_css += `}`;
      }

      if(_.isObject(row.settings.title_margin_bottom)){
        title_css += `#${rowId} .sppb-section-title .sppb-title-heading{`;
        title_css += `margin-bottom: ${row.settings.title_margin_bottom.md}px;`;
        title_css += `}`;

        title_css_sm += `#${rowId} .sppb-section-title .sppb-title-heading{`;
        title_css_sm += `margin-bottom: ${row.settings.title_margin_bottom.sm}px;`;
        title_css_sm += `}`;

        title_css_xs += `#${rowId} .sppb-section-title .sppb-title-heading{`;
        title_css_xs += `margin-bottom: ${row.settings.title_margin_bottom.xs}px;`;
        title_css_xs += `}`;
      } else {
        title_css += `#${rowId} .sppb-section-title .sppb-title-heading{`;
        title_css += `margin-bottom: ${row.settings.title_margin_bottom}px;`;
        title_css += `}`;
      }

      if (row.settings.subtitle !== undefined && row.settings.subtitle != '') {
        if(_.isObject(row.settings.subtitle_fontsize)){
          title_css += `#${rowId} .sppb-section-title .sppb-title-subheading{`;
          title_css += `font-size: ${row.settings.subtitle_fontsize.md}px;line-height: ${row.settings.subtitle_fontsize.md}px;`;
          title_css += `}`;
  
          title_css_sm += `#${rowId} .sppb-section-title .sppb-title-subheading{`;
          title_css_sm += `font-size: ${row.settings.subtitle_fontsize.sm}px;line-height: ${row.settings.subtitle_fontsize.sm}px;`;
          title_css_sm += `}`;
  
          title_css_xs += `#${rowId} .sppb-section-title .sppb-title-subheading{`;
          title_css_xs += `font-size: ${row.settings.subtitle_fontsize.xs}px;line-height: ${row.settings.subtitle_fontsize.xs}px;`;
          title_css_xs += `}`;
        } else {
          title_css += `#${rowId} .sppb-section-title .sppb-title-subheading{`;
          title_css += `font-size: ${row.settings.subtitle_fontsize}px;line-height: ${row.settings.subtitle_fontsize}px;`;
          title_css += `}`;
        }
      }
    }

    var extVideo = this.externalVideo();

    return connectDragPreview(connectDropTarget(
      <div
        key={id}
        className={overClass}>
        <div className="addon-placeholder-top"><i className="fa fa-sort" /></div>
        <div className="sp-pagebuilder-section-inner-wrap">
          <div className="clearfix">
            <div className="sp-pagebuilder-row-tools clearfix">
              { connectDragSource(
                <span className="sp-pagebuilder-drag-row"><i className="pbfont pbfont-drag"></i></span>
              )}

              {
                row.visibility &&
                <ColumnLayout
                  changeColumn={this.props.changeColumnGen}
                  rowIndex={ index }
                  current={ row.layout }
                  />
              }
              <RowSettings row={row} index={index} />
            </div>
            <style type="text/css">
              {
                `
                #${rowId}{
                    ${padding.md}
                    ${margin.md}
                }
                #${rowId} .sppb-shape-container.sppb-top-shape > svg{
                  ${topShapeCss}
                }
                #${rowId} .sppb-shape-container.sppb-top-shape > svg path,
                #${rowId} .sppb-shape-container.sppb-top-shape > svg polygon{
                  fill: ${row.settings.shape_color};
                }

                #${rowId} .sppb-shape-container.sppb-bottom-shape > svg{
                  ${bottomShapeCss}
                }
                #${rowId} .sppb-shape-container.sppb-bottom-shape > svg path,
                #${rowId} .sppb-shape-container.sppb-bottom-shape > svg polygon{
                  fill: ${row.settings.bottom_shape_color};
                }
                ${title_css}
                @media (min-width: 768px) and (max-width: 991px) {
                  #${rowId}{
                    ${padding.sm}
                    ${margin.sm}
                  }

                  #${rowId} .sppb-shape-container.sppb-top-shape > svg{
                    ${topShapeCss_sm}
                  }

                  #${rowId} .sppb-shape-container.sppb-bottom-shape > svg{
                    ${bottomShapeCss_sm}
                  }

                  ${title_css_sm}
                }
                @media (max-width: 767px) {
                  #${rowId}{
                    ${padding.xs}
                    ${margin.xs}
                  }

                  #${rowId} .sppb-shape-container.sppb-top-shape > svg{
                    ${topShapeCss_xs}
                  }

                  #${rowId} .sppb-shape-container.sppb-bottom-shape > svg{
                    ${bottomShapeCss_xs}
                  }
                  ${title_css_xs}
                }
                `
              }
            </style>
            <div className="sp-pagebuilder-section">
              <div className={customClass}>
                {
                  fluid_row == 0
                  ?
                  <section
                    id={rowId}
                    className={sectionClass}
                    data-sppb-wow-duration={animationduration}
                    data-sppb-wow-delay={animationdelay}
                    style={styles}>

                    {
                      (typeof row.settings.overlay !== 'undefined' && row.settings.overlay != '') &&
                      <div className="sppb-row-overlay" style={overlayStyle}></div>
                    }

                    <div className="sppb-row-container">
                      {extVideo}
                      {
                        (row.settings.show_top_shape !== undefined && row.settings.show_top_shape && row.settings.shape_name !== undefined && row.settings.shape_name != '')
                        ?
                        <div className={`sppb-shape-container sppb-top-shape ${shapeClass}`} dangerouslySetInnerHTML={{__html: atob(topShape)}} />
                        :
                        ''
                      }

                      {
                        (row.settings.show_bottom_shape !== undefined && row.settings.show_bottom_shape && row.settings.bottom_shape_name !== undefined && row.settings.bottom_shape_name != '')
                        ?
                        <div className={`sppb-shape-container sppb-bottom-shape ${bottomShapeClass}`} dangerouslySetInnerHTML={{__html: atob(bottomShape)}} />
                        :
                        ''
                      }
                      {
                        cusHtml &&
                        <div dangerouslySetInnerHTML={ { __html: cusHtml } } />
                      }
                      

                      <div className={row_class}>
                        { row.columns.map( (column, index) =>
                          {
                            return(
                              <Column
                                key={column.id}
                                id={column.id}
                                column={column}
                                rowIndex={rowIndex}
                                index={index}
                                colLength = {colLength}
                                columnMove={this.props.columnSortable} />
                            )
                          }
                        )}
                      </div>
                    </div>
                  </section>
                  :
                  <div
                    id={rowId}
                    className={sectionClass}
                    data-sppb-wow-duration={animationduration}
                    data-sppb-wow-delay={animationdelay}
                    style={styles}
                    >
                    {
                      (typeof row.settings.overlay !== 'undefined' && row.settings.overlay != '') &&
                      <div className="sppb-row-overlay" style={overlayStyle}></div>
                    }
                    <div className="sppb-container-inner">
                      {
                        cusHtml &&
                        <div dangerouslySetInnerHTML={ { __html: cusHtml } } />
                      }
                      {extVideo}
                      {
                        (row.settings.show_top_shape !== undefined && row.settings.show_top_shape && row.settings.shape_name !== undefined && row.settings.shape_name != '')
                        ?
                        <div className={`sppb-shape-container sppb-top-shape ${shapeClass}`} dangerouslySetInnerHTML={{__html: atob(sppbSvgShape[row.settings.shape_name])}} />
                        :
                        ''
                      }
  
                      {
                        (row.settings.show_bottom_shape !== undefined && row.settings.show_bottom_shape && row.settings.bottom_shape_name !== undefined && row.settings.bottom_shape_name != '')
                        ?
                        <div className={`sppb-shape-container sppb-bottom-shape ${bottomShapeClass}`} dangerouslySetInnerHTML={{__html: atob(sppbSvgShape[row.settings.bottom_shape_name])}} />
                        :
                        ''
                      }
                      <div className={row_class}>
                        { row.columns.map( (column, index) =>
                          {
                            return(
                              <Column
                                key={column.id}
                                id={column.id}
                                column={column}
                                rowIndex={rowIndex}
                                index={index}
                                colLength = {colLength}
                                columnMove={this.props.columnSortable} />
                            )
                          }
                        )}
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div className="sppb-row-bottom-new-row">
            <AddNewRowButton bottom={true} index={index} />
          </div>
        </div>
        <div className="addon-placeholder-bottom"><i className="fa fa-sort" /></div>
      </div>
    ))
  }
}

var DragSourceDecorator = DragSource( ItemTypes.ROW, rowSource,
  function(connect, monitor) {
    return {
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging()
    };
  }
);

var DropTargetDecorator = DropTarget([ItemTypes.ROW, ItemTypes.BLOCK], rowTarget,
  function(connect, monitor) {
    return {
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      isOverCurrent: monitor.isOver({ shallow: true })
    };
  }
);

const mapStateToProps = ( state ) => {
  return {state};
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    addBlockAsRow: ( rowIndex, rowData ) => {
      dispatch(addBlock(rowIndex, rowData))
    },
    columnSortable: ( rowIndex, dragIndex, hoverIndex ) => {
      dispatch(columnSortable(rowIndex, dragIndex, hoverIndex))
    },
    changeColumnGen: ( colLayout, current, rowIndex ) => {
      dispatch(changeColumn( colLayout, current, rowIndex ))
    },
    toggleCollapse: (id) => {
      dispatch(toggleCollapse(id))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DropTargetDecorator(DragSourceDecorator(Row)));



// WEBPACK FOOTER //
// ./src/components/Row.js